import { useState, useEffect, useRef } from "react";
import sanityClient from "../../sanityClient";
// import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
// import { faPlay, faPause } from "@fortawesome/free-solid-svg-icons";
import { PortableText } from "@portabletext/react";

export default function HomeExpert() {
  const [homeExpertContent, setHomeExpertContent] = useState({ title: "", description: "" });
  const [bannerData, setBannerData] = useState(null);
  const [isPlaying, setIsPlaying] = useState(false);
  const videoRef = useRef(null);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [expertData, bannerData] = await Promise.all([
          sanityClient.fetch(`*[_type == "homePageContent"][0].homeDesignExpertise{title, description}`),
          sanityClient.fetch(`*[_type == "bannerImageSection" && page == "homedesignexpertise"][0]{ 
            bannerType, "imageUrl": bannerImage.asset->url, bannerVideoUrl, altText 
          }`),
        ]);

        setHomeExpertContent((prev) => (JSON.stringify(prev) !== JSON.stringify(expertData) ? expertData : prev));
        setBannerData((prev) => (JSON.stringify(prev) !== JSON.stringify(bannerData) ? bannerData : prev));
      } catch (error) {
        console.error("Error fetching data:", error);
      }
    };

    fetchData();
  }, []);

  const handlePlayPause = () => {
    if (bannerData?.bannerType === "video") {
      if (bannerData.bannerVideoUrl.includes("youtube")) {
        setIsPlaying(!isPlaying);
      } else if (videoRef.current) {
        isPlaying ? videoRef.current.pause() : videoRef.current.play();
        setIsPlaying(!isPlaying);
      }
    }
  };

  return (
    <section className="home-expert">
      <div className="container">
        <div className="row align-items-center">
          <div className="col-lg-6 col-md-6">
            <div className="expertise-video">
              {bannerData && (
                <>
                  {!isPlaying ? (
                    <img src={bannerData.imageUrl} alt={bannerData.altText} className="img-responsive" loading="lazy" />
                  ) : bannerData.bannerType === "video" && bannerData.bannerVideoUrl.includes("youtube") ? (
                    <iframe
                      className="img-responsive"
                      src={`${bannerData.bannerVideoUrl}?autoplay=1&mute=1`}
                      title="YouTube Video"
                      frameBorder="0"
                      allow="autoplay; encrypted-media; picture-in-picture"
                      allowFullScreen
                      loading="lazy"
                    ></iframe>
                  ) : (
                    <video className="img-responsive" src={bannerData.bannerVideoUrl} ref={videoRef} muted loop playsInline />
                  )}
                </>
              )}

              {/* <button className="play-expert" onClick={handlePlayPause} aria-label={isPlaying ? "Pause video" : "Play video"}>
                <FontAwesomeIcon icon={isPlaying ? faPause : faPlay} />
              </button> */}
            </div>
          </div>

          <div className="col-lg-6 col-md-6">
            <div className="expertise-detail wow animate__animated animate__fadeInUp" data-wow-duration="1s" data-wow-delay="0.2s">
              <img src="./assets/home/shape-vector.png" alt="vector" />
              <h4 className="heading">{homeExpertContent.title}</h4>
              <PortableText value={homeExpertContent.description} />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
